module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("热门搜索标签设置")])])], 1), _vm._v(" "), _c('el-form', {
    ref: "hotForm",
    attrs: {
      "model": _vm.hotForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "热门关键词设置",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.hot),
      callback: function($$v) {
        _vm.hot = $$v
      },
      expression: "hot"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "描述",
      "label-width": "150px"
    }
  }, [_c('div', _vm._l((_vm.row), function(item) {
    return _c('el-tag', {
      key: item,
      staticStyle: {
        "margin-right": "10px"
      },
      attrs: {
        "type": "warning",
        "closable": true,
        "close-transition": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45d91c60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/other/HotSearch.vue
// module id = 728
// module chunks = 1